import jwt_decode from 'jwt-decode';
import React, { useState, useContext, createContext } from "react";
import { locale, addLocale } from 'primereact/api';

const InfoContext = createContext({});

function GeneralInfo({children}){
    const [today] = useState(new Date())
    const [user,setUser] = useState()
    addLocale('pt-BR', {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Claro'
  });
  locale('pt-BR');

  function nomeUsuario(token){
    const decoded = jwt_decode(token);
    setUser(decoded.usuario_nome);
  }
    
    return (
      <InfoContext.Provider
        value={{
            today,
            user,
            nomeUsuario
        }}
      >
        {children}
      </InfoContext.Provider>
        )
    }
    
function useInfo(){
        const context = useContext(InfoContext);
        return context;
    }
    
export {useInfo,GeneralInfo}    
